'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245 from "./presto.ui.-Inputs$-Input-Type$$anon$5.js";
var $p;
function $s_Lpresto_ui_Inputs$InputType$__text__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__text;
}
export { $s_Lpresto_ui_Inputs$InputType$__text__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__text__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__password__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__password;
}
export { $s_Lpresto_ui_Inputs$InputType$__password__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__password__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__number__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__number;
}
export { $s_Lpresto_ui_Inputs$InputType$__number__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__number__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__tel__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__tel;
}
export { $s_Lpresto_ui_Inputs$InputType$__tel__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__tel__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__email__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__email;
}
export { $s_Lpresto_ui_Inputs$InputType$__email__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__email__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__range__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__range;
}
export { $s_Lpresto_ui_Inputs$InputType$__range__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__range__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__search__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__search;
}
export { $s_Lpresto_ui_Inputs$InputType$__search__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__search__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__url__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__url;
}
export { $s_Lpresto_ui_Inputs$InputType$__url__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__url__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__color__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__color;
}
export { $s_Lpresto_ui_Inputs$InputType$__color__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__color__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__date__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__date;
}
export { $s_Lpresto_ui_Inputs$InputType$__date__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__date__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__datetime$minuslocal__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__datetime$minuslocal;
}
export { $s_Lpresto_ui_Inputs$InputType$__datetime$minuslocal__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__datetime$minuslocal__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__month__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__month;
}
export { $s_Lpresto_ui_Inputs$InputType$__month__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__month__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__time__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__time;
}
export { $s_Lpresto_ui_Inputs$InputType$__time__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__time__Lpresto_ui_Inputs$InputType };
function $s_Lpresto_ui_Inputs$InputType$__week__Lpresto_ui_Inputs$InputType() {
  $m_Lpresto_ui_Inputs$InputType$();
  return $t_Lpresto_ui_Inputs$InputType$__week;
}
export { $s_Lpresto_ui_Inputs$InputType$__week__Lpresto_ui_Inputs$InputType as $s_Lpresto_ui_Inputs$InputType$__week__Lpresto_ui_Inputs$InputType };
/** @constructor */
function $c_Lpresto_ui_Inputs$InputType$() {
  $n_Lpresto_ui_Inputs$InputType$ = this;
  $t_Lpresto_ui_Inputs$InputType$__text = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(0, "text", this);
  $t_Lpresto_ui_Inputs$InputType$__password = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(1, "password", this);
  $t_Lpresto_ui_Inputs$InputType$__number = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(2, "number", this);
  $t_Lpresto_ui_Inputs$InputType$__tel = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(3, "tel", this);
  $t_Lpresto_ui_Inputs$InputType$__email = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(4, "email", this);
  $t_Lpresto_ui_Inputs$InputType$__range = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(5, "range", this);
  $t_Lpresto_ui_Inputs$InputType$__search = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(6, "search", this);
  $t_Lpresto_ui_Inputs$InputType$__url = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(7, "url", this);
  $t_Lpresto_ui_Inputs$InputType$__color = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(8, "color", this);
  $t_Lpresto_ui_Inputs$InputType$__date = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(9, "date", this);
  $t_Lpresto_ui_Inputs$InputType$__datetime$minuslocal = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(10, "datetime-local", this);
  $t_Lpresto_ui_Inputs$InputType$__month = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(11, "month", this);
  $t_Lpresto_ui_Inputs$InputType$__time = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(12, "time", this);
  $t_Lpresto_ui_Inputs$InputType$__week = new $j_presto$002eui$002e$002dInputs$0024$002dInput$002dType$0024$0024anon$00245.$c_Lpresto_ui_Inputs$InputType$$anon$5(13, "week", this);
  $s_Lpresto_ui_Inputs$InputType$__text__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__password__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__number__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__tel__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__email__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__range__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__search__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__url__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__color__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__date__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__datetime$minuslocal__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__month__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__time__Lpresto_ui_Inputs$InputType();
  $s_Lpresto_ui_Inputs$InputType$__week__Lpresto_ui_Inputs$InputType();
}
export { $c_Lpresto_ui_Inputs$InputType$ as $c_Lpresto_ui_Inputs$InputType$ };
$p = $c_Lpresto_ui_Inputs$InputType$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ui_Inputs$InputType$;
/** @constructor */
function $h_Lpresto_ui_Inputs$InputType$() {
}
export { $h_Lpresto_ui_Inputs$InputType$ as $h_Lpresto_ui_Inputs$InputType$ };
$h_Lpresto_ui_Inputs$InputType$.prototype = $p;
var $d_Lpresto_ui_Inputs$InputType$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ui_Inputs$InputType$, "presto.ui.Inputs$InputType$", ({
  a42: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_ui_Inputs$InputType$ as $d_Lpresto_ui_Inputs$InputType$ };
var $n_Lpresto_ui_Inputs$InputType$;
function $m_Lpresto_ui_Inputs$InputType$() {
  if ((!$n_Lpresto_ui_Inputs$InputType$)) {
    $n_Lpresto_ui_Inputs$InputType$ = new $c_Lpresto_ui_Inputs$InputType$();
  }
  return $n_Lpresto_ui_Inputs$InputType$;
}
export { $m_Lpresto_ui_Inputs$InputType$ as $m_Lpresto_ui_Inputs$InputType$ };
var $t_Lpresto_ui_Inputs$InputType$__text = null;
function $u_Lpresto_ui_Inputs$InputType$__text(x) {
  $t_Lpresto_ui_Inputs$InputType$__text = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__text as $t_Lpresto_ui_Inputs$InputType$__text, $u_Lpresto_ui_Inputs$InputType$__text as $u_Lpresto_ui_Inputs$InputType$__text };
var $t_Lpresto_ui_Inputs$InputType$__password = null;
function $u_Lpresto_ui_Inputs$InputType$__password(x) {
  $t_Lpresto_ui_Inputs$InputType$__password = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__password as $t_Lpresto_ui_Inputs$InputType$__password, $u_Lpresto_ui_Inputs$InputType$__password as $u_Lpresto_ui_Inputs$InputType$__password };
var $t_Lpresto_ui_Inputs$InputType$__number = null;
function $u_Lpresto_ui_Inputs$InputType$__number(x) {
  $t_Lpresto_ui_Inputs$InputType$__number = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__number as $t_Lpresto_ui_Inputs$InputType$__number, $u_Lpresto_ui_Inputs$InputType$__number as $u_Lpresto_ui_Inputs$InputType$__number };
var $t_Lpresto_ui_Inputs$InputType$__tel = null;
function $u_Lpresto_ui_Inputs$InputType$__tel(x) {
  $t_Lpresto_ui_Inputs$InputType$__tel = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__tel as $t_Lpresto_ui_Inputs$InputType$__tel, $u_Lpresto_ui_Inputs$InputType$__tel as $u_Lpresto_ui_Inputs$InputType$__tel };
var $t_Lpresto_ui_Inputs$InputType$__email = null;
function $u_Lpresto_ui_Inputs$InputType$__email(x) {
  $t_Lpresto_ui_Inputs$InputType$__email = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__email as $t_Lpresto_ui_Inputs$InputType$__email, $u_Lpresto_ui_Inputs$InputType$__email as $u_Lpresto_ui_Inputs$InputType$__email };
var $t_Lpresto_ui_Inputs$InputType$__range = null;
function $u_Lpresto_ui_Inputs$InputType$__range(x) {
  $t_Lpresto_ui_Inputs$InputType$__range = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__range as $t_Lpresto_ui_Inputs$InputType$__range, $u_Lpresto_ui_Inputs$InputType$__range as $u_Lpresto_ui_Inputs$InputType$__range };
var $t_Lpresto_ui_Inputs$InputType$__search = null;
function $u_Lpresto_ui_Inputs$InputType$__search(x) {
  $t_Lpresto_ui_Inputs$InputType$__search = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__search as $t_Lpresto_ui_Inputs$InputType$__search, $u_Lpresto_ui_Inputs$InputType$__search as $u_Lpresto_ui_Inputs$InputType$__search };
var $t_Lpresto_ui_Inputs$InputType$__url = null;
function $u_Lpresto_ui_Inputs$InputType$__url(x) {
  $t_Lpresto_ui_Inputs$InputType$__url = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__url as $t_Lpresto_ui_Inputs$InputType$__url, $u_Lpresto_ui_Inputs$InputType$__url as $u_Lpresto_ui_Inputs$InputType$__url };
var $t_Lpresto_ui_Inputs$InputType$__color = null;
function $u_Lpresto_ui_Inputs$InputType$__color(x) {
  $t_Lpresto_ui_Inputs$InputType$__color = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__color as $t_Lpresto_ui_Inputs$InputType$__color, $u_Lpresto_ui_Inputs$InputType$__color as $u_Lpresto_ui_Inputs$InputType$__color };
var $t_Lpresto_ui_Inputs$InputType$__date = null;
function $u_Lpresto_ui_Inputs$InputType$__date(x) {
  $t_Lpresto_ui_Inputs$InputType$__date = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__date as $t_Lpresto_ui_Inputs$InputType$__date, $u_Lpresto_ui_Inputs$InputType$__date as $u_Lpresto_ui_Inputs$InputType$__date };
var $t_Lpresto_ui_Inputs$InputType$__datetime$minuslocal = null;
function $u_Lpresto_ui_Inputs$InputType$__datetime$minuslocal(x) {
  $t_Lpresto_ui_Inputs$InputType$__datetime$minuslocal = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__datetime$minuslocal as $t_Lpresto_ui_Inputs$InputType$__datetime$minuslocal, $u_Lpresto_ui_Inputs$InputType$__datetime$minuslocal as $u_Lpresto_ui_Inputs$InputType$__datetime$minuslocal };
var $t_Lpresto_ui_Inputs$InputType$__month = null;
function $u_Lpresto_ui_Inputs$InputType$__month(x) {
  $t_Lpresto_ui_Inputs$InputType$__month = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__month as $t_Lpresto_ui_Inputs$InputType$__month, $u_Lpresto_ui_Inputs$InputType$__month as $u_Lpresto_ui_Inputs$InputType$__month };
var $t_Lpresto_ui_Inputs$InputType$__time = null;
function $u_Lpresto_ui_Inputs$InputType$__time(x) {
  $t_Lpresto_ui_Inputs$InputType$__time = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__time as $t_Lpresto_ui_Inputs$InputType$__time, $u_Lpresto_ui_Inputs$InputType$__time as $u_Lpresto_ui_Inputs$InputType$__time };
var $t_Lpresto_ui_Inputs$InputType$__week = null;
function $u_Lpresto_ui_Inputs$InputType$__week(x) {
  $t_Lpresto_ui_Inputs$InputType$__week = x;
}
export { $t_Lpresto_ui_Inputs$InputType$__week as $t_Lpresto_ui_Inputs$InputType$__week, $u_Lpresto_ui_Inputs$InputType$__week as $u_Lpresto_ui_Inputs$InputType$__week };
//# sourceMappingURL=presto.ui.-Inputs$-Input-Type$.js.map
